import { styled } from '@mui/material';


const Height45Weight500 = styled('button')`
	height: 45px;
	font-weight: 500;
	text-align: center;
`;


export const PinkHeight45FullWidthButton = styled(Height45Weight500)`
	width: 100%;
	color: #ffffff;
	font-size: 16px;
	border: none;
	border-radius: 22.5px;
	background: linear-gradient(0deg, #DA3192 0%, #F600BE 100%);
	opacity: 1;
	transition: opacity 150ms;

	&:hover:not([disabled]) {
		background: linear-gradient(0deg, #DA3192 0%, #F600BE 0%);
	}
	&:focus:not([disabled]) {
		background: linear-gradient(-180deg, #DA3192 0%, #F600BE 100%);
	}

	&[disabled] {
		opacity: 0.4;
	}
`;

export const BlueHeight45FullWidthButton = styled(Height45Weight500)`
	width: 100%;
	color: #ffffff;
	font-size: 16px;
	border: none;
	border-radius: 22.5px;
	background: linear-gradient(0deg, #00ACED 0%, #1CC1FF 100%);
	opacity: 1;
	transition: opacity 150ms;

	&:hover:not([disabled]) {
		background: linear-gradient(0deg, #00ACED 0%, #1CC1FF 0%);
	}
	&:focus:not([disabled]) {
		background: linear-gradient(-180deg, #00ACED 0%, #1CC1FF 100%);
	}

	&[disabled] {
		opacity: 0.4;
	}
`;
